import { render, staticRenderFns } from "./IconEmojiSadOutline.vue?vue&type=template&id=cd3a27bc"
import script from "./IconEmojiSadOutline.vue?vue&type=script&lang=js"
export * from "./IconEmojiSadOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports